import { OverrideDataProvider } from '@interfaces/global';
import LogsClass from '@parse_entity_utils/logs';

const LogsDataProvider: Pick<OverrideDataProvider<any>, 'getOne' | 'getList'> = {
    getList: LogsClass.getList,
    getOne: LogsClass.getOne,
};

export default LogsDataProvider;
